document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".flipper-card");

  cards.forEach((card) => {
    const inner = card.querySelector(".flipper-inner");

    card.addEventListener("click", (e) => {
      if (e.target.closest("a")) return;

      const isCurrentlyFlipped = inner.classList.contains("is-flipped");

      cards.forEach((otherCard) => {
        if (otherCard !== card) {
          const otherInner = otherCard.querySelector(".flipper-inner");
          otherInner.classList.remove("is-flipped");
        }
      });

      if (!isCurrentlyFlipped) {
        inner.classList.add("is-flipped");
      } else {
        inner.classList.remove("is-flipped");
      }
    });
  });
});
